import React, { useMemo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Collapse } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./styles/adrAttachmentPreview.css";
import adrActions from "../../_actions/adrActions";
import { contextTypes } from "../../_constants/fileUploadContextTypes";

export default function AdrGeneralCommentAttachmentsV3(props) {
  const {
    comment,
    projectId,
    toggleModal_fileUpload,
    showGcaBlock,
    toggleGcaBlock,
    tabId,
  } = props;

  const dispatch = useDispatch();

  const jobStamp = useSelector((state) => state.projects.jobStamps[projectId] || null);
  const handleClick_edit = (e) => {
    e.preventDefault();
    toggleModal_fileUpload();
  };

  const handleClick_download_all = async (e) => {
    e.preventDefault();
    const attachments = comment ? comment.commentAttachments || [] : [];
    const files = attachments
      .filter((a) => !a.isDeleted)
      .map((a) => ({
        filePath: a.filePath,
        fileNameAlias: a.originalFileName,
      }));
    if (jobStamp) await dispatch(adrActions.requestAttachments(jobStamp.fullEA, files));
  };

  const handleClick_toggleDelete = (fileRowIndex) => (e) => {
    e.preventDefault();
    e.stopPropagation();
    const params = {
      tabId,
      clientId: comment.clientId,
      gcaIndex: fileRowIndex,
    };
    dispatch(adrActions.toggleDeleteAttachment(params, contextTypes.GC));
  };

  // const getFileName = useCallback(
  //   (fileRowIndex) => comment.commentAttachments[fileRowIndex].originalFileName,
  //   []
  // );

  const renderThumbnail = (attachment, fileRowIndex) => {
    const ext = attachment.originalFileName
      ? attachment.originalFileName.split(".").pop().toLowerCase()
      : "";
    let icon = "file";
    if (["doc", "docx"].includes(ext)) icon = "file-word";
    else if (["xls", "xlsx"].includes(ext)) icon = "file-excel";
    else if (ext === "pdf") icon = "file-pdf";
    else if (ext === "zip") icon = "file-archive";

    const deleteButton = (
      <button
        name="toggleDeleteAttachment"
        className={`btn btn-sm thumbnail-delete-button ${
          attachment.isDeleted ? "btn-outline-success" : "btn-outline-danger"
        }`}
        onClick={handleClick_toggleDelete(fileRowIndex)}
      >
        {attachment.isDeleted ? (
          <FontAwesomeIcon icon="trash-restore" className="fa-fw" />
        ) : (
          <FontAwesomeIcon icon="trash-alt" className="fa-fw" />
        )}
      </button>
    );

    return (
      <div
        onClick={(e) => { e.preventDefault(); e.stopPropagation(); dispatch(adrActions.openFile(attachment.filePath)); }}
        className="pointer-cursor"
      >
        {deleteButton}
        {attachment.imageThumbnailFilePath ? (
          <img
            src={attachment.thumbnailBase64}
            alt="(Cannot display thumbnail)"
            className="thumbnail"
          />
        ) : (
          <FontAwesomeIcon icon={["far", icon]} className="fa-fw fa-3x" />
        )}
      </div>
    );
  };

  const attachments = useMemo(
    () => (comment ? comment.commentAttachments || [] : []),
    [comment]
  );

  return (
    <div className="gc-row-att">
      <div className="card mb-2 w-100 bg-lightgray">
        <div className="card-body p-2">
          <div className="mb-0 gc-subsection-toggler" onClick={toggleGcaBlock}>
            <FontAwesomeIcon
              icon={showGcaBlock ? "caret-down" : "caret-right"}
              className="fa-fw mr-1"
            />
            <b>
              <i>Preview Attached Photos</i>
            </b>
            <span className="badge badge-pill badge-danger my-auto ml-2">
              {attachments && attachments.length}
            </span>
          </div>
          <Collapse isOpen={showGcaBlock}>
            <div className="d-flex flex-row flex-wrap">
              {attachments &&
                attachments.map((gca, index) => (
                  <div
                    key={`gcaPreviewKey_${gca.clientId}_${index}`}
                    className="card m-1 align-self-start"
                  >
                    <div className="card-body p-2 thumbnail-content">
                      {renderThumbnail(gca, index)}
                    </div>
                  </div>
                ))}
              <div className="card m-1">
                <div className="card-body p-2 btn-edit-attachment-container">
                  <div className="d-flex flex-column flex-fill">
                    <div className="mb-1">
                      <button
                        type="button"
                        name="editAttachments"
                        id={`editGca_${comment.clientId}`}
                        className="btn btn-outline-secondary mb-1 btn-edit-attachment"
                        onClick={handleClick_edit}
                      >
                        <FontAwesomeIcon icon="edit" className="fa-fw mr-2" />
                        Edit...
                      </button>
                    </div>
                    <div>
                      <button
                        type="button"
                        name="requestAttachments"
                        id={`downloadAllLas_${comment.clientId}`}
                        className="btn btn-outline-secondary btn-edit-attachment mb-1"
                        onClick={handleClick_download_all}
                      >
                        <FontAwesomeIcon icon="download" className="fa-fw mr-2" />
                        Download All
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Collapse>
        </div>
      </div>
    </div>
  );
}
